export const MonsterType = [
    "Aberration",
    "Celestisches Wesen",
    "Drache",
    "Elementar",
    "Feenwesen",
    "Humanoide (Echsenmensch)",
    "Humanoide (Elf)",
    "Humanoide (Gnoll)",
    "Humanoide (Gnom)",
    "Humanoide (Goblinoide)",
    "Humanoide (Grimlock)",
    "Humanoide (Kobold)",
    "Humanoide (Meervolk)",
    "Humanoide (Mensch)",
    "Humanoide (Ork)",
    "Humanoide (Sahuagin)",
    "Humanoide (Zwerg)",
    "Humanoide (jedes Volk)",
    "Konstrukt",
    "Monstrosität",
    "Monstrosität (Gestaltwandler)",
    "Monstrosität (Titan)",
    "Pflanze",
    "Riese",
    "Schlick",
    "Schwarm winziger Tiere",
    "Tier",
    "Unhold",
    "Unhold (Dämon)",
    "Unhold (Gestaltwandler)",
    "Unhold (Teufel)",
    "Untoter",
    "Untoter (Gestaltwandler)"
]